import { useMemo } from 'react';

import { Context } from './context';

export const useContentContext = (
  parent: Context,
  { isLoading, error }: { isLoading?: boolean; error?: Error },
): Context =>
  useMemo(
    () => ({ ...parent, isLoading: Boolean(isLoading), error }),
    [parent, isLoading, error],
  );
